<template>
  <div>
    <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
      <b-col>
        <div id="map" class="map"></div>
        <div class="text-center margin-top-home">
          <div class="inline">
            <fa-icon icon="question-circle" v-tooltip:right="`Open Series is the most flexible way to race. You can do the race whenever you want. You are ranked based on your final time (stages time + penalty on transfers if any).`" />
            &nbsp;&nbsp;
            <img src="../../public/openseries.png" width="120px">
            <span class="bigger-font-x2">Top Races</span>
            &nbsp;
            <img src="../../public/flag.png" width="25px">
          </div>
          <br><br>
          <span class="failure">{{ failureMessage }}</span>
          <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4">
            <b-col 
              v-for="race in topRaces"
              :key="race.id"
              class="margin-top-bottom"
            >
              <router-link class="text-black text-decoration-none" :to="{ name: 'Race', params: { id: race.id }}">
                <b-card :img-src="race.recommendedRoute.stravaDetails.map_urls.url" :img-alt="race.name" img-top>
                  <b-card-text>
                    <img src="../../public/flag.png" width="25px">&nbsp;
                    <h5 class="inline">{{ race.name }}</h5>
                    <span v-if="race.isEBike">&nbsp;<img src="../../public/thunder.png" width="20px"></span>
                    <br>
                    <br>
                    <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                      <b-col>
                        <b>Riders:</b> {{ race.riders }}
                        <br><br>
                        <b>Stages:</b> {{ race.itineary | numberOfStages }}
                      </b-col>
                      <b-col>
                        <b>Distance:</b> {{ race.recommendedRoute.stravaDetails.distance | metersToKilometers }} km
                        <br><br>
                        <b>Elevation:</b> {{ race.recommendedRoute.stravaDetails.elevation_gain | meters }} m
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </div>
        <div class="text-center margin-top-home">
          <div class="inline">
            <fa-icon icon="question-circle" v-tooltip:right="`Trophy Series is a more challenging way to race. A trophy is organized by a club. A trophy is made of one or multiple races that have to be done within specific dates. You score points on each race based on your ranking. Your overall trophy ranking is based on your total points.`" />
            &nbsp;&nbsp;
            <img src="../../public/trophyseries.png" width="120px">
            <span class="bigger-font-x2">Top Trophies</span>
            &nbsp;
            <img src="../../public/trophy.png" width="30px">
          </div>
          <br><br>
          <span class="failure">{{ failureMessage }}</span>
          <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4">
            <b-col 
              v-for="trophy in topTrophies"
              :key="trophy.id"
              class="margin-top-bottom"
            >
              <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: trophy.id }}">
                <b-card>
                  <b-card-text>
                    <img src="../../public/trophy.png" width="30px">&nbsp;
                    <h5 class="inline">{{ trophy.name }}</h5>
                    <br>
                    <span>Club: {{ trophy.club.name }}</span>
                    <br>
                    <br>
                    <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                      <b-col>
                        <b>Participants:</b> {{ trophy.riders }}
                        <br><br>
                        <b>Start date:</b> {{ trophy.startDate | date }}
                      </b-col>
                      <b-col>
                        <b>Races:</b> {{ trophy.races }}
                        <br><br>
                        <b>End date:</b> {{ trophy.endDate | date }}
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-modal ref="racesAtLocation" size="xl" title="Races at this location" hide-footer>
      <div class="d-block">
        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col 
            v-for="race in racesAtLocation"
            :key="race.id"
            class="margin-top-bottom"
          >
            <div>
              <router-link class="text-black text-decoration-none" :to="{ name: 'Race', params: { id: race.id }}">
                <b-card>
                  <b-card-text>
                    <img src="../../public/flag.png" width="25px">&nbsp;
                    <h5 class="inline">{{race.name }}</h5>
                    <span v-if="race.isEBike">&nbsp;<img src="../../public/thunder.png" width="20px"></span>
                    <br>
                    <br>
                    <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                      <b-col>
                        <b>Riders:</b> {{ race.riders }}
                        <br><br>
                        <b>Stages:</b> {{ numberOfStages(race.itineary) }}
                      </b-col>
                      <b-col>
                        <b>Distance:</b> {{ metersToKilometers(race.recommendedRoute.stravaDetails.distance) }} km
                        <br><br>
                        <b>Elevation:</b> {{ meters(race.recommendedRoute.stravaDetails.elevation_gain) }} m
                      </b-col>
                    </b-row>
                  </b-card-text>
                  <div v-if="race.racesTrophy">
                    <br>
                    This race is part of the following trophies:
                  </div>
                  <div
                    v-for="raceTrophy in race.racesTrophy"
                    :key="raceTrophy.id"
                  >
                    <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: raceTrophy.trophy.id }}">
                      <b-card>
                        <b-card-text>
                          <img src="../../public/trophy.png" width="30px">&nbsp;
                          <h5 class="inline">{{ raceTrophy.trophy.name }}</h5>
                          &nbsp;&nbsp;<span>Club: {{ raceTrophy.trophy.club.name }}</span>
                          <br>
                          <br>
                          <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                            <b-col>
                              <b>Trophy start date:</b> {{ raceTrophy.trophy.startDate | date }}
                              <br><br>
                              <b>Trophy end date:</b> {{ raceTrophy.trophy.endDate | date }}
                            </b-col>
                            <b-col>
                              <b>Participants:</b> {{ raceTrophy.trophy.riders }}
                              <br><br>
                              <b>Races:</b> {{raceTrophy.trophy.races }}
                            </b-col>
                          </b-row>
                          <br>
                          (Race is between the {{ raceTrophy.startDate | date }} and the {{ raceTrophy.endDate | date }})
                        </b-card-text>
                      </b-card>
                    </router-link>
                  </div>
                </b-card>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>

  import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

  export default {
    name: 'Home',
    components: {  },
    props: {

    },
    data() {
      return {
        failureMessage: '',
        races: [],
        trophies: [],
        topRaces: [],
        topTrophies: [],
        geolocation: null,
        geoOptions: {
          maximumAge: 5 * 60 * 1000,
        },
        map: null,
        racesAtLocation: [],
        racesMapping: {}
      }
    },
    async created() {

    },
    async mounted() {
      navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError, this.geoOptions);

      await this.listTopRaces()
      await this.listTopTrophies()

      const { races, trophies } = await this.listRacesWithRacesTrophy()

      const mapData = {
        races,
        trophies
      }

      this.loadMap(mapData)
    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      showModal(name) {
        if (Array.isArray(this.$refs[name])) {
          this.$refs[name][0].show()
        } else {
          this.$refs[name].show()
        }
      },
      viewEventsAtLocation(markers) {
        this.racesAtLocation = []

        for (let i=0; i < markers.length; i++) {
          const marker = markers[i]

          if (marker.type === 'Race') {
            if (this.racesMapping[marker.id]) {
              this.racesAtLocation.push(this.racesMapping[marker.id])
            }
          }
        }

        this.showModal('racesAtLocation');
      },
      geoSuccess(position) {
        this.geolocation = position

        if (this.map) {
          this.map.flyTo({
            center: [this.geolocation.coords.longitude, this.geolocation.coords.latitude],
            zoom: 6
          });
        }
      },
      geoError(error) {
        console.log('Error occurred when getting geolocation. Error code: ' + error.code);
        // error.code can be:
        //   0: unknown error
        //   1: permission denied
        //   2: position unavailable (error response from location provider)
        //   3: timed out
      },
      async listTopRaces() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listTopRaces.graphql'),
          variables: {
            limit: 4
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listTopRaces) {
          this.topRaces.push(...result.data.listTopRaces)
        }
      },
      async listTopTrophies() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listTopTrophies.graphql'),
          variables: {
            limit: 4
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listTopTrophies) {
          this.topTrophies.push(...result.data.listTopTrophies)
        }
      },
      async listRacesWithRacesTrophy() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/listRacesWithRacesTrophy.graphql'),
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listRacesWithRacesTrophy) {
          this.races.push(...result.data.listRacesWithRacesTrophy)

          const trophies = []

          const races = this.races.map(race => {

            if (race.racesTrophy) {
              race.racesTrophy.map(raceTrophy => {
                trophies.push({
                  'type': 'Feature',
                  'geometry': {
                    'type': 'Point',
                    'coordinates': [race.location.longitude, race.location.latitude]
                  },
                  'properties': {
                    'id': raceTrophy.trophy.id,
                    'type': 'Trophy',
                    'name': raceTrophy.trophy.name,
                    'participants': raceTrophy.trophy.riders,
                    'races': raceTrophy.trophy.races,
                    'startDate': this.$options.filters.date(raceTrophy.trophy.startDate),
                    'endDate': this.$options.filters.date(raceTrophy.trophy.endDate),
                  }
                })
              })
            }

            this.racesMapping[race.id] = race

            return {
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': [race.location.longitude, race.location.latitude]
              },
              'properties': {
                'id': race.id,
                'type': 'Race',
                'isEBike': race.isEBike,
                'name': race.name,
                'stages': this.numberOfStages(race.itineary),
                'distance': this.metersToKilometers(race.recommendedRoute.stravaDetails.distance),
                'elevation': this.meters(race.recommendedRoute.stravaDetails.elevation_gain),
                'riders': race.riders
              }
            }
          })

          return {
            races,
            trophies
          }
        }
      },
      loadMap({ races, trophies }) {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_API_KEY;

        this.map = new mapboxgl.Map({
          container: 'map',
          zoom: 1.5,
          pitch: 0,
          center: [7, 49],
          bearing: 0,
          style: 'mapbox://styles/marcvander/ckvuz25zg3gqz14t7m63owekh'
        });

        if (this.geolocation) {
          this.geoSuccess(this.geolocation)
        }

        this.map.on('load', () => {
          this.map.loadImage(
            'https://cdn-icons-png.flaticon.com/32/1505/1505471.png',
            (error, image) => {
              if (error) throw error;
              this.map.addImage('race', image);

              this.map.addSource('racesAndTrophies', {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': [...races, ...trophies]
                },
                cluster: true,
                clusterMaxZoom: 25, // Max zoom to cluster points on
                clusterRadius: 50 // Radius of each cluster when clustering points 
              });

              this.map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'racesAndTrophies',
                filter: ['has', 'point_count'],
                paint: {
                  // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                  // with three steps to implement three types of circles:
                  //   * Blue, 20px circles when point count is less than 5
                  //   * Yellow, 30px circles when point count is between 5 and 20
                  //   * Pink, 40px circles when point count is greater than or equal to 20
                  'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    '#ffc859',
                    5,
                    '#ffc859',
                    20,
                    '#ffc859'
                  ],
                  'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    5,
                    25,
                    20,
                    30
                  ]
                }
              });

              this.map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'racesAndTrophies',
                filter: ['has', 'point_count'],
                layout: {
                  'text-field': '{point_count_abbreviated}',
                  'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                  'text-size': 12
                }
              });

              // We assign the icon-image 'race' because wherever there is a trophy, there is a race
              // Thus the cluster is always shown instead of the trophy. Thus we cannot directly see a trophy
              // But we can see a race
              this.map.addLayer({
                'id': 'racesAndTrophies',
                'type': 'symbol',
                'source': 'racesAndTrophies',
                filter: ['!', ['has', 'point_count']],
                'layout': {
                  'icon-image': 'race',
                  'icon-allow-overlap': true,
                  'text-field': ['get', 'name'],
                  'text-font': [
                    'Open Sans Semibold',
                    'Arial Unicode MS Bold'
                  ],
                  'text-offset': [0, 0],
                  'text-anchor': 'top'
                },
                'paint': {
                  'text-color': '#000',
                }
              });
            }
          )

          const that = this

          // inspect a cluster on click
          this.map.on('click', 'clusters', (e) => {
            const features = this.map.queryRenderedFeatures(e.point, {
              layers: ['clusters']
            });
            const clusterId = features[0].properties.cluster_id;
            this.map.getSource('racesAndTrophies').getClusterExpansionZoom(
              clusterId,
              (err, expansionZoom) => {
                if (err) return;

                const currentZoom = this.map.getZoom();
                if (currentZoom < 15) {
                  this.map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom: expansionZoom
                  });
                } else {
                  this.map.getSource('racesAndTrophies').getClusterLeaves(
                    clusterId,
                    100,
                    0,
                    function (err, leafFeatures) {
                      if (err) {
                        return console.error('error while getting leaves of a cluster', err);
                      }
                      const markers = _.map(leafFeatures, function(leafFeature) {
                        return leafFeature.properties;
                      });

                      that.viewEventsAtLocation(markers)
                    }
                  );
                }
              }
            );
          });

          // When a click event occurs on a feature in the places layer, open a popup at the
          // location of the feature, with description HTML from its properties.
          // We only manage the click on a race and not a trophy because wherever there is a trophy, there is a race
          // Thus the cluster is always shown instead of the trophy. Thus we cannot directly click on a trophy
          // But we can click on a race
          this.map.on('click', 'racesAndTrophies', (e) => {
            // Copy coordinates array.
            const coordinates = e.features[0].geometry.coordinates.slice();
            const id = e.features[0].properties.id;
            const bikeType = e.features[0].properties.isEBike ? '(E-Bike)' : '';
            const name = e.features[0].properties.name;
            const stages = e.features[0].properties.stages;
            const distance = e.features[0].properties.distance;
            const elevation = e.features[0].properties.elevation;
            const riders = e.features[0].properties.riders;

            const html = `
              <strong>${name}</strong>&nbsp;${bikeType}
              <p> 
                <b>Riders:</b> ${riders}
                <br>
                <b>Stages:</b> ${stages}
                <br>
                <b>Distance:</b> ${distance} km
                <br>
                <b>Elevation:</b> ${elevation} m
                <br>
                <a href=${process.env.VUE_APP_FRONT_URL}/race/${id}><strong>View</strong></a>
              </p>
            `
            
            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            
            new mapboxgl.Popup()
              .setLngLat(coordinates)
              .setHTML(html)
              .addTo(this.map);
          });
          
          // Change the cursor to a pointer when the mouse is over the places layer.
          this.map.on('mouseenter', 'racesAndTrophies', () => {
            this.map.getCanvas().style.cursor = 'pointer';
          });
          
          // Change it back to a pointer when it leaves.
          this.map.on('mouseleave', 'racesAndTrophies', () => {
            this.map.getCanvas().style.cursor = '';
          });
        })
      },
      meters(value) {
        return value.toFixed(0)
      },
      metersToKilometers(value) {
        return (value / 1000).toFixed(2)
      },
      numberOfStages(itineary) {
        return itineary.filter(step => step.type === 'stage').length
      }
    }
  }
</script>

<style scoped>

</style>
